import React, { useRef, useEffect } from 'react';
import {
    MdHistory,
    MdAnalytics,
    MdAccountBalanceWallet,
    MdPersonOff,
    MdExitToApp,
    MdClose
} from 'react-icons/md';
import styles from './GameSwipeSettings.module.css';
import { 
  usePlayerSeat as useGamePlayerSeat,
  useSitOutOption
} from '@/src/hooks/data/useGameTable';
import { doesExist } from '@/Common/utils/GameUtils';
import HandHistory from '../HandHistory/HandHistory';
import Topup from '../Topup/Topup';
import TableStats from '../TableStats/TableStats';
import useGameConnection from '@/src/hooks/data/useGameConnection';

export default function GameSwipeSettings({ tempTableId, isOpen, onToggle }) {
    const containerRef = useRef(null);
    const playerSeat = useGamePlayerSeat(tempTableId);
    const sitOutOption = useSitOutOption(tempTableId);
    const { connected } = useGameConnection(tempTableId);

    useEffect(() => {
        if (containerRef.current && isOpen) {
            // Scroll to the settings container
            containerRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }, [isOpen]);

    const handleAction = (action) => {
        console.log(`Action triggered: ${action} for table: ${tempTableId}`);
        // TODO: Implement actual action handlers
        onToggle(); // Close settings after action
    };

    return connected ? (
        <div className={styles.settingsSnapContainer} ref={containerRef}>
            <div className={styles.container}>
                <div className={styles.actionsRow}>
                    {/* Utility Components */}
                    {doesExist(playerSeat) && (
                        <>
                            <div className={styles.actionItem}>
                                <Topup tempTableId={tempTableId} />
                            </div>
                            <div className={styles.actionItem}>
                                <HandHistory tempTableId={tempTableId} />
                            </div>
                            <div className={styles.actionItem}>
                                <TableStats tempTableId={tempTableId} />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    ) : null;
}
